export default "__VITE_ASSET__848899ef__"